import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = { class: "columns is-centered is-multiline is-mobile" }
const _hoisted_4 = {
  key: 0,
  class: "column is-full"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "column is-full" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "connection-details-header" })
], -1)
const _hoisted_6 = { class: "column is-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_holding_screen = _resolveComponent("holding-screen")!
  const _component_settings_list_container = _resolveComponent("settings-list-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.store.data.store.setupComplete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_holding_screen)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_settings_list_container, { settings: _ctx.settings }, null, 8, ["settings"])
              ])
            ], 64))
      ])
    ])
  ]))
}